import React from 'react';
import ReactGA from 'react-ga';
import Mobile from './../components/mobile/Mobile';
import Header from './../components/header/Header';
import Container from './../components/container/Container';
import Footer from './../components/footer/Footer';
import './../style/App.css';
import {isMobile} from 'react-device-detect';
//import { createStore } from 'redux';
//import fire from './fire';

class App extends React.Component {
    constructor() {
        super();
        this.state = {
          someData: null,
        };
    
        ReactGA.initialize('UA-117404026-1');
        ReactGA.pageview(window.location.pathname);
    }

    renderContent() {
        if (isMobile) {
            return <div><Mobile /></div>
        }
        return (
            <div className="App">
                <Header/>
                <Container/>
                <Footer/>
            </div>
        )
    }
     
    render() {
        return this.renderContent();
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/pages/App.js